import React from 'react';
import { generateSubText } from '../../../shared/utils/campaigns/utils-subtext';
import { StCampaignMetaLabel, StCampaignMetaValue, StEditIcon, StSubText } from './MetaDataStyles';
import { useTranslation } from 'react-i18next';

interface Props {
    campaignEndDate?: string;
    daysLeft?: number;
    icon?: string;
    showEndDateEditButton: boolean;
    onEditButtonClick?: () => void;
    showSubText?: boolean;
    loansLeft?: number;
    daysLeftInHours?: number;
}

const EndDate = (props: Props) => {
    const { t } = useTranslation();
    const {
        campaignEndDate,
        daysLeft,
        icon = '',
        showEndDateEditButton,
        onEditButtonClick,
        showSubText,
        loansLeft,
        daysLeftInHours
    } = props;

    const subText = generateSubText(daysLeftInHours, loansLeft, daysLeft);
    const displaySubText = showSubText ? (
        <div data-testid="end-date">
            <StCampaignMetaLabel />
            <StCampaignMetaValue>
                <StSubText data-testid="subtext">
                    {subText?.timeLeft
                        ? t(`marketing.yourCampaigns.${subText.key}`, { count: subText.timeLeft })
                        : subText
                        ? t(`marketing.yourCampaigns.${subText.key}`)
                        : ''}
                </StSubText>
            </StCampaignMetaValue>
        </div>
    ) : null;

    const editIcon = showEndDateEditButton ? <StEditIcon onClick={onEditButtonClick} icon={icon} /> : null;

    return (
        <React.Fragment>
            <StCampaignMetaLabel>{t('marketing.yourCampaigns.campaignEnd')}:</StCampaignMetaLabel>
            <StCampaignMetaValue>
                {campaignEndDate
                    ? t('dateFormat.date', {
                          val: new Date(campaignEndDate)
                      })
                    : null}
                {editIcon}
            </StCampaignMetaValue>
            {displaySubText}
        </React.Fragment>
    );
};

export default EndDate;
